// extracted by mini-css-extract-plugin
export var container = "_ma-0";